import { jsx } from "react/jsx-runtime";
import { SellerAddressSearch } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
const SELLER_ADDRESS_SEARCH_CONFIG_VALUES = {
  test: {
    origin: "https://www.qa.zillow.net",
    graphURL: "https://zg-graph-stage.int.zgcp-federated-nonprod-k8s.zg-int.net/graphql/"
  },
  prod: {
    origin: "https://www.zillow.com",
    graphURL: "https://www.zillow.com/graphql/"
  }
};
const BlockSellerAddressSearch = ({
  attrs
}) => {
  const NEXT_PUBLIC_ENV = process.env.NEXT_PUBLIC_ENV;
  return /* @__PURE__ */ jsx(SellerAddressSearch, { propertySearchConfigValues: SELLER_ADDRESS_SEARCH_CONFIG_VALUES[NEXT_PUBLIC_ENV] || SELLER_ADDRESS_SEARCH_CONFIG_VALUES.test, ...attrs });
};
BlockSellerAddressSearch.propTypes = {
  attrs: PropTypes.shape({
    id: PropTypes.string,
    placeholder: PropTypes.string,
    size: PropTypes.oneOf(["sm", "md", "lg"])
  }),
  index: PropTypes.number
};
export {
  SELLER_ADDRESS_SEARCH_CONFIG_VALUES,
  BlockSellerAddressSearch as default
};
